import { ACTIVE_FILE_ID_PARAM, THEME_ID_PARAM } from "./urlParams.ts";

export const copilotRoutes = {
  pricing: "/pricing",
  termsOfUse: "/terms-of-use",
  privacyPolicy: "/privacy-policy",
};

export const editorRoutes = {
  home: "/",
  onboarding: "/welcome",
  file: "/file",
  theme: "/theme",
  prototype: "/prototype",
  logout: "/logout",
  settings: "/settings",
  settingsAccount: "/settings/account",
  settingsBilling: "/settings/billing",
  settingsPeople: "/settings/people",
  settingsOrganisation: "/settings/organisation",
  settingsFigma: "/settings/figma",
  settingsReferrals: "/settings/referrals",
  // auth
  login: "/login",
  register: "/register",
  resetPassword: "/resetpassword",
  resetPasswordSuccess: "/resetpassword/success",
  newPassword: "/newpassword",
  newPasswordSuccess: "/newpassword/success",
  newPasswordError: "/newpassword/error",
  verifyEmail: "/verify-email",
};

export const getFileRoute = (fileId: string) => {
  return `${editorRoutes.file}?${ACTIVE_FILE_ID_PARAM}=${fileId}`;
};

export const getOrgRoute = (orgId: string) => {
  return `${editorRoutes.home}?orgId=${orgId}`;
};

export const getThemeRoute = (themeId: string) => {
  return `${editorRoutes.theme}?${THEME_ID_PARAM}=${themeId}`;
};

export const getPrototypeRoute = (fileId: string) => {
  return `${editorRoutes.prototype}?${ACTIVE_FILE_ID_PARAM}=${fileId}`;
};
